import React, { useMemo, useRef, useCallback, useEffect } from "react";
import Button from "devextreme-react/button";
import DataGrid, {
  Column,
  ColumnChooser,
  ColumnFixing,
  Paging,
  Pager,
  SearchPanel,
  Toolbar,
  Item,
  StateStoring,
  Scrolling
} from "devextreme-react/data-grid";
import "./index.scss";
import { IMdaeDataGridProps, IMdaeExport } from "./index";
import { useDispatch } from "react-redux";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import $ from "jquery";
import DevExtremeDataGrid from 'devextreme/ui/data_grid';
import saveAs from 'file-saver';
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { UPDATE_PREFERENCE } from "../../../pages/external-dashboard/services/update-preference";
import { GET_PREFERENCE } from "../../../pages/external-dashboard/services/get-preference";
import { callOperation } from "async-ops";
import { setIsGridSettingCalled } from "../../user-task-list/component";
import { SET_GENERIC_DATAGRID_SELECTED_ROW_ID } from "../../mdae-common-reducer";

export const saveGridSetting = (
  state,
  mdaeStateStoring?,
  isNotGridSetting?
) => {
  if (
    ( state &&
      state?.pageSize &&
      state?.pageSize !== 0) ||
      isNotGridSetting
  ) {    
    callOperation(UPDATE_PREFERENCE, {
      name: mdaeStateStoring.storageKey,
      settings: JSON.stringify(state),
      reportType: null,
    });
  }
};

export const loadGridState = async (dispatch, mdaeStateStoring?) => {
  if (mdaeStateStoring.isUserTaskDataGrid) {
    if (!mdaeStateStoring.isGetGridSettingCalled) {
      setIsGridSettingCalled(dispatch, true);
      return getUserPreference(mdaeStateStoring.storageKey).then(
        (gridSettingDb) => {
          if (typeof mdaeStateStoring.onBeforeLoadGridState === "function") {
            mdaeStateStoring.onBeforeLoadGridState(gridSettingDb);
          }
          return gridSettingDb;
        }
      );
    }
  } else {
    return getUserPreference(mdaeStateStoring.storageKey).then(
      (gridSettingDb) => {
        if (typeof mdaeStateStoring.onBeforeLoadGridState === "function") {
          mdaeStateStoring.onBeforeLoadGridState(gridSettingDb);
        }
        return gridSettingDb;
      }
    );
  }
};

const getUserPreference = (cacheKey) => {
return callOperation(GET_PREFERENCE, {
  name: cacheKey
}).then((response) =>{
  var gridSettingDb = JSON.parse(response?.settings); 
  if (!gridSettingDb) {
    var localStorageGridSetting = localStorage.getItem(cacheKey);
    if (localStorageGridSetting) {
      var data = { name: cacheKey, settings: localStorageGridSetting };
      return callOperation(UPDATE_PREFERENCE, {
        name: data.name,
        settings: data.settings,
        reportType: null,
      }).then(() => {
        gridSettingDb = JSON.parse(localStorageGridSetting);
        return gridSettingDb;
      });
    }
    else{
      return gridSettingDb;
    }
  }
  else{
    return gridSettingDb;
  }
});
};

const onColumnChoosePopupInstanceShowing = (e) => {
  $(e.component.content())
    .parents(".dx-overlay-wrapper")
    .addClass("datagrid-column-chooser-overlay-wrapper-height");
};
const setupColumnChooserPopupPosition = (dataGridInstance) => {
  if (dataGridInstance) {
    if (dataGridInstance && dataGridInstance.option("columnChooser")) {
      if (dataGridInstance.option('columnChooser').visible != true) {
        dataGridInstance.option('columnChooser.visible', true);
        dataGridInstance.option('columnChooser.visible', false);
      }
      var columnChooserView = dataGridInstance.getView("columnChooserView");
      if (columnChooserView) {
        var columnChooserPopupInstance = columnChooserView
          .element()
          .data("dxPopup");
        if (columnChooserPopupInstance) {
          columnChooserPopupInstance.option("position.at", "right top");
          columnChooserPopupInstance.option("position.my", "right top");
          columnChooserPopupInstance.option("height", 300);
          columnChooserPopupInstance.off(
            "shown",
            onColumnChoosePopupInstanceShowing
          );
          columnChooserPopupInstance.on(
            "shown",
            onColumnChoosePopupInstanceShowing
          );
        }
      }
    }
  }
};

const clearButtonFilterTemplate = () => {
  return (
    <span className="fa-layers fa-fw sys-data-grid-clear-filter-icon-container">
      <FontAwesomeIcon
        className={"sys-data-grid-filter-icon "}
        icon={faFilter}
        size={"lg"}
      ></FontAwesomeIcon>
      <FontAwesomeIcon
        icon={faTimes}
        size={"sm"}
        className={"fa-times-style sys-data-grid-filter-times-icon"}
      />
    </span>
  );
};

const getColumnChooserProps = (props) => {
  if (props.mdaeColumnChooser?.isMdaeColumnChooserVisible) {
    return {
      enabled: true,
      allowSearch: true,
      mode: "dragAndDrop",
      ...props.mdaeColumnChooser,
    };
  } else {
    return {
      enabled: false,
    };
  }
};


const onExporting = (e, exportObj: IMdaeExport) => {
  if (exportObj?.enabled) {
    if (typeof exportObj.beforeExporting === "function") {
      exportObj.beforeExporting(e);
    }
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      customizeCell: function(options) {
        if(typeof(exportObj.customizeExcelCell) === 'function'){
          exportObj.customizeExcelCell(options);
        }        
        const { gridCell, excelCell } = options;
        excelCell.font = { name: "Calibri", size: 11 };
        excelCell.alignment = { horizontal: "left" };  
        if (gridCell.rowType === "header") {
          excelCell.font.bold = true;
          excelCell.alignment.wrapText = false;     
      }          
      },
    }).then(function() {
      workbook.xlsx.writeBuffer().then(function(buffer) {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          `${exportObj.fileName || "DataGrid"}.xlsx`
        );
      });
      if (typeof exportObj.afterExporting === "function") {
        exportObj.afterExporting(e);
      }      
    });
    e.cancel = true;
  }
};

const MdaeDataGrid: React.FC<IMdaeDataGridProps> = (props) => {
  const dispatch = useDispatch();
  const dataGridRef = useRef(null);
  const dataGridInstance:DevExtremeDataGrid = dataGridRef?.current?.instance;
  const clearFilterButtonId = props.clearFilterButtonId
    ? props.clearFilterButtonId
    : "btn-clear-filter";
  const applyColorToFilterButton = useCallback(function (instance) {
    if (instance?.getCombinedFilter()) {
      $("#" + clearFilterButtonId + " .dx-button-content").addClass(
        "application-section-primary-color"
      );
    } else {
      $("#" + clearFilterButtonId + " .dx-button-content").removeClass(
        "application-section-primary-color"
      );
    }
  }, [clearFilterButtonId]);
  
  const columns = useMemo(():JSX.Element[] => {
    return props.mdaeColumns?.map((element, index) => {
      const columnUniqueKey = props.id + "ColumnKey" + index;
      if (element.type === "buttons") {
        return (
          <Column {...element} key={columnUniqueKey}>
            {element.buttons.map((field) => {
              return <Button {...field} />;
            })}
          </Column>
        );
      } else {
        return <Column {...element} key={columnUniqueKey} />;
      }
    });
  }, [props.mdaeColumns]);

  const dataGridProps = useMemo(() => {
    return {
      onInitialized: (e) => {
        if (typeof props.onInitialized === "function") props.onInitialized(e);
        configureMdaeWidgetOptionUpdaters(
          props.mdaeDataUpdaterConfig,
          DX_WIDGET_NAMES.DX_DATA_GRID,
          e.component,
          dispatch
        );
      },
      onOptionChanged: (e) => {
        if (typeof props.onOptionChanged === "function")
          props.onOptionChanged(e);
        if (e.name.toLowerCase() === "paging") {
          if (e.component.option("paging.enabled")) {
            if (
              e.component.option("paging.pageSize") > e.component.totalCount()
            ) {
              e.component.option("pager.visible", true);
            }
          }
        }
      },
    };
  }, [
    configureMdaeWidgetOptionUpdaters,
    props.onInitialized,
    props.onOptionChanged,
    props.mdaeDataUpdaterConfig,
  ]);
  
  useEffect(() => {
    if(dataGridInstance){
      if (props.mdaeColumnChooser?.isMdaeColumnChooserVisible){
          setupColumnChooserPopupPosition(dataGridInstance);
      }
    }
  })

  const elementAttr = useMemo(() => {
    return {
      class: "sys-mdae-data-grid-base-class",
    };
  }, []);

  const onExportingCallback = useCallback((e) => onExporting(e, props.export), [
    props.export,
  ]);

  const onContentReadyCallback = useCallback(
    (e) => {
      if (typeof props.onContentReady === "function") props.onContentReady(e);
      applyColorToFilterButton(e.component);
      if (e.component.getSelectedRowsData()?.length === 0) {
        dispatch({
          type: SET_GENERIC_DATAGRID_SELECTED_ROW_ID,
          genericDataGridSelectedRowId: null,
        });
      }
    },
    [props.mdaeColumnChooser, props.onContentReady, applyColorToFilterButton]
  );

  const clearFilterButtonRender = useCallback(
    (e) => {
      return (
        props.clearFilterButtonId && (
          <Button
            elementAttr={{
              id: clearFilterButtonId,
              title: "Clear Filter",
              class: "sys-data-grid-clear-filter-button filter-button",
            }}
            stylingMode="text"
            icon=""
            text=""
            render={clearButtonFilterTemplate}
            onClick={function() {
              const instance = dataGridRef?.current?.instance;
              instance?.clearFilter();
              instance?.option("searchPanel.text", "");
              const visibleColumns = instance?.getVisibleColumns();
              visibleColumns?.forEach(function(col) {
                instance?.columnOption(
                  col.dataField,
                  "selectedFilterOperation",
                  undefined
                );
              });
              if (typeof props.onDataGridClearFilterClick === "function") {
                props.onDataGridClearFilterClick(instance);
              }
            }}
          />
        )
      );
    },
    [
      props.onDataGridClearFilterClick,
      clearButtonFilterTemplate,
      clearFilterButtonId,
    ]
  );
  const stateStoringOnCutomLoadCallback = useCallback(() => {
    return loadGridState(dispatch, props.mdaeStateStoring);
  }, [loadGridState, props.mdaeStateStoring]);

  const stateStoringOnCustomSaveCallback = useCallback(
    (state) => {
      saveGridSetting(state, props.mdaeStateStoring);
    },
    [props.mdaeStateStoring, saveGridSetting]
  );
  return (
    <DataGrid
      ref={dataGridRef}
      {...props}
      elementAttr={elementAttr}
      {...dataGridProps}
      onExporting={onExportingCallback} 
      onContentReady={onContentReadyCallback}
      rowAlternationEnabled={
        props.rowAlternationEnabled === false ? false : true
      }
      showColumnLines={props.showColumnLines === false ? false : true}
      showRowLines={props.showRowLines === false ? false : true}
      showBorders={props.showBorders === false ? false : true}
    >
      <Scrolling mode={"standard"} />
      <Paging defaultPageSize={props.pageSize || 10} />
      <Pager
        showPageSizeSelector={true}
        showNavigationButtons={true}
        allowedPageSizes={[10, 20, 30]}
        showInfo={true}
        visible={props.paging?.enabled === false ? false : true}
      />
      <Toolbar
        visible={Boolean(
          props.mdaeDataGridCustomButtonsBefore ||
            props.mdaeDataGridCustomButtons ||
            props.clearFilterButtonId ||
            props.export?.enabled ||
            props.mdaeSearchPanel?.visible ||
            props.mdaeColumnChooser?.isMdaeColumnChooserVisible ||
            props.searchPanel?.visible
        )}
      >
        <Item
          location="before"
          component={props?.mdaeDataGridCustomButtonsBefore}
        />
        <Item location="after" render={props?.mdaeDataGridCustomButtons} />
        <Item
          location="after"
          visible={Boolean(props.clearFilterButtonId)}
          render={clearFilterButtonRender}
        />
        <Item name="exportButton" />
        <Item name="columnChooserButton" locateInMenu="never"/>
        <Item
          name="searchPanel"
          visible={Boolean(
            props.searchPanel?.visible || props.mdaeSearchPanel?.visible
          )}
        />
        <Item name="groupPanel" visible={Boolean(props.groupPanel?.visible)} />
        <Item
          location="after"
          component={props?.mdaeDataGridCustomButtonsEnd}
        />
      </Toolbar>

      <SearchPanel {...props.mdaeSearchPanel} />
      <ColumnChooser
        {...getColumnChooserProps(props)}
        sortOrder={props?.mdaeColumnChooser?.sortOrder || "asc"}
      />
      <ColumnFixing {...props.columnFixing} />
      {columns}
      {props.children}
      {props.mdaeStateStoring && (
        <StateStoring
          enabled={props.mdaeStateStoring?.enabled ? true : false}
          type="custom"
          customLoad={stateStoringOnCutomLoadCallback}
          customSave={stateStoringOnCustomSaveCallback}
        />
      )}
    </DataGrid>
  );
};
export default MdaeDataGrid;
